// extracted by mini-css-extract-plugin
export default {"title":"MobileUserEnteringPage_title__DTeP8","text":"MobileUserEnteringPage_text__PU8Uu"};